const actionTypes = {
  CACHE_GAME_HIGH_SCORE: 'CACHE_GAME_HIGH_SCORE',
};
export default actionTypes;
